import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { GaEventsService } from 'src/app/_services/ga-events.service';
import { FreemiumAPIService, FreeTrialRequest } from '../freemium-api.service';
import { FreemiumService } from '../freemium.service';
declare var $: any; // used to access jQuery
@Component({
    selector: 'app-seven-day-free-trial-modal',
    templateUrl: './seven-day-free-trial-modal.component.html',
    styleUrls: ['./seven-day-free-trial-modal.component.scss'],
    standalone: false
})
export class SevenDayFreeTrialModalComponent implements OnInit {

  freeTrialForm: UntypedFormGroup = new UntypedFormGroup({
    firstName: new UntypedFormControl(null, Validators.required),
    lastName: new UntypedFormControl(null, Validators.required),
    designation: new UntypedFormControl(null, Validators.required),
    workEmail: new UntypedFormControl(null, Validators.compose([Validators.required, Validators.pattern('^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$')])),
    phoneNumber: new UntypedFormControl(null, Validators.required),
    companyname:new UntypedFormControl(null, Validators.required),
    linkedinUrl: new UntypedFormControl(null, Validators.compose([ Validators.required, Validators.pattern(/^https?:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?$/)
      ])
    )
  })
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  SearchCountryField = SearchCountryField;
  // TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  domainList:any[] =  FreemiumService.invalid_workemail_domain_list;
  showErrorMsg: string;
  @ViewChild("freeTrialSuccess")
  freeTrialSuccess: TemplateRef<NgbModalRef>;
  response: any;
  showFreeTrialLoader: Boolean = false;
  @ViewChild('carousel') _carousel!: ElementRef;
  constructor(private freemiumApiService: FreemiumAPIService, private modalService: NgbModal, private gaService: GaEventsService) { }
  ngAfterViewInit() {
    const carouselElem = this._carousel?.nativeElement;
    const carousel = $(carouselElem).carousel();
  }
  ngOnInit() {
    this.freeTrialForm.get('workEmail').valueChanges.subscribe(res=>{
      if(res) {
        const invaliEmail = this.domainList.filter(x=>res.includes(x));
        if(invaliEmail.length > 0) {
          this.freeTrialForm.get('workEmail').setErrors({'invaliDomain': true});
        } else {
          this.freeTrialForm.get('workEmail').setErrors(null, {emitEvent: false});
        }
      }
    })
  }

  register() { 
    this.showErrorMsg = null;
    if(this.freeTrialForm.valid) {
      this.showFreeTrialLoader = true;

      const request = {
        firstname: this.freeTrialForm.getRawValue().firstName,
        lastname: this.freeTrialForm.getRawValue().lastName,
        designation: this.freeTrialForm.getRawValue().designation,
        workemail: this.freeTrialForm.getRawValue().workEmail,
        countrycode: this.freeTrialForm.getRawValue().phoneNumber.dialCode,
        phonenumber: this.freeTrialForm.getRawValue().phoneNumber.number,
        companyname:this.freeTrialForm.getRawValue().companyname,
        linkedinUrl:this.freeTrialForm.getRawValue().linkedinUrl
      }
      this.freemiumApiService.freeTrialRegistration(request).subscribe((res:any) => {
        this.response = res;
        this.showFreeTrialLoader = false;

        if(this.response && this.response.status == "success") {
          const modalRef = this.modalService.open(this.freeTrialSuccess, {
            size: "modal-free-trial-success",
            centered: true,
            backdrop: "static",
            keyboard: false,
          });
          this.freeTrialForm.reset();
      /**
     * GA tracking for Insights page visit
     */
    this.gaService.trackButtonClick('Get_Start_Free_Trial_Click_Success');
        }
       }, (error:any)=>{
        this.showFreeTrialLoader = false;

        if(error.status == 400 && error.error.message == "Free trial request already submitted")
          this.showErrorMsg = "Free trial request already submitted";
        else if(error.status == 400 && error.error.message == "User already exists")
           this.showErrorMsg = "User already exists";
        else if(error.status == 400 && error.error.message == "Invalid work email")
          this.showErrorMsg = "Invalid work email";
             /**
     * GA tracking for Insights page visit
     */
    this.gaService.trackButtonClick('Get_Start_Free_Trial_Click_Error');
       })
    }



  }

  dismiss() {
    this.modalService.dismissAll();
  }

}
